// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.border[data-v-0f6d399b] {\n  border-radius: 20px 20px 0px 0px !important;\n}\n.canvas-border[data-v-0f6d399b] {\n  border-radius: 0px 0px 20px 20px !important;\n}\n.custom-panel-heading[data-v-0f6d399b] {\n  border-radius: 20px 20px 0 0 !important;\n  background-color:#495057 !important;\n}\n.dashboard-jobs-chart[data-v-0f6d399b] {\n  height: 300px;\n}\n", ""]);
// Exports
module.exports = exports;
